<template>
    <div class="is-block">
        <div class="tabs is-toggle is-fullwidth">
            <ul>
                <li :class="{'is-active': inPrivacy}" @click="inPrivacy=true,inParticipants=false">
                <a :class="{'has-background-primary': inPrivacy}">
                    
                    <span class="icon is-small">
                            <i class="mdi mdi-18px mdi-eye-settings"></i>
                        </span>
                    <span>{{$t('privacy')}}</span>
                </a>
                </li>
                <li :class="{'is-active': inParticipants}" @click="inPrivacy=false,inParticipants=true">
                <a :class="{'has-background-primary': inParticipants}">
                    <span class="icon is-small">
                            <i class="mdi mdi-18px mdi-account-multiple"></i>
                        </span>
                    <span>{{$t('project_participants_option')}}</span>
                </a>
                </li>
                
            </ul>
        </div>
        <div v-if="inPrivacy">
            <div>
                <div>
                    <h4
                        v-t="'privacy'"
                        class="is-title is-uppercase has-text-weight-bold is-size-6"
                    />
                    <p v-t="'privacy_option_description'" />
                </div>
                <hr />
                <div
                    v-for="privacy in privacyOptions"
                    :key="privacy"
                    class="control is-flex my-5"
                >
                    <label class="radio has-text-weight-bold pt-3">
                        <input
                            v-model="project.privacy"
                            :checked="project.privacy == privacy"
                            :value="privacy"
                            type="radio"
                        />
                    </label>
                    <div class="pl-3">
                        <p class="has-text-weight-bold">
                            {{ $t(`projectConfiguration.privacy_${privacy}`) }}
                        </p>
                        <p>
                            {{
                                $t(
                                    `projectConfiguration.privacy_${privacy}_description`
                                )
                            }}
                        </p>
                    </div>
                </div>
                <div class="py-3" v-if="canAllowAnonymous">
                    <div class="level mb-1">
                        <div class="level-left">
                            <div class="level-item">
                                <p
                                    v-t="`project.settings.allow_anonymous`"
                                    class="title is-6"
                                ></p>
                            </div>
                        </div>
                        <div class="level-right">
                            <div class="level-item">
                                <label class="switch">
                                    <input
                                        v-model="allowAnonymous"
                                        type="checkbox"
                                        @change="setAllowAnonymous"
                                    />
                                    <span class="slider round"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <p class="is-size-7 has-text-grey">
                        {{ $t('project.settings.allow_anonymous_desc') }}
                    </p>
                </div>
            </div>
            <hr />
            <div>
                <div class="py-3">
                    <h4
                        v-t="'projectConfiguration.accessLevel_title'"
                        class="is-title is-uppercase has-text-weight-bold is-size-6"
                    />
                    <p
                        v-t="'projectConfiguration.accessLevel_description'"
                        class="is-size-7"
                    ></p>
                </div>
                <hr />

                <div class="columns is-centered">
                    <div
                        v-for="permission in permissionOptions"
                        :key="permission"
                        class="column has-text-centered is-4"
                        @click="project.defaultPermission = permission"
                    >
                        <button
                            :class="{
                                'is-active has-background-pale-grey':
                                    project.defaultPermission == permission,
                            }"
                            class="
                                button
                                lb-project-privacy-option
                                has-background-very-light-pink
                                is-paddingless
                            "
                        >
                            <span class="icon is-large">
                                <i :class="iconForPermission(permission)" />
                            </span>
                        </button>
                        <p
                            v-t="`projectConfiguration.access_${permission}`"
                            :class="{
                                'has-text-info':
                                    project.defaultPermission == permission,
                            }"
                        />
                    </div>
                </div>
                <div class="notification is-info is-light mb-6 mt-2">
                    <p
                        v-t="
                            `projectConfiguration.access_${project.defaultPermission}_description`
                        "
                    ></p>
                </div>
            </div>
        </div>
        <project-configuration-participants 
        v-if="inParticipants" 
        :project="project"
      />
    </div>
</template>

<script>
import {
    PRIVACY_OPTIONS,
    GLOBAL_PERMISSION_OPTIONS,
    SCHOOL_PRIVACY_OPTIONS,
} from '@/lib/constants';
import ProjectConfigurationParticipants from '@/components/ProjectConfigurationParticipants';

export default {
    components: {
        ProjectConfigurationParticipants,
    },
    model: {
        prop: 'project',
    },
    props: {
        project: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {
            globalPrivacyOptions: PRIVACY_OPTIONS,
            schoolPrivacyOptions: SCHOOL_PRIVACY_OPTIONS,
            permissionOptions: GLOBAL_PERMISSION_OPTIONS,
            allowAnonymous: this.project.allowAnonymous | false,
            inPrivacy: true,
            inParticipants: false,
        };
    },
    computed: {
        privacyOptions() {
            if (this.$store.getters.hasSchool) {
                return this.schoolPrivacyOptions;
            }
            return this.globalPrivacyOptions;
        },
        canAllowAnonymous() {
            return (
                this.project.privacy == 'secret' ||
                this.project.privacy == 'public'
            );
        },
    },
    methods: {
        iconForPermission: function (privacy) {
            switch (privacy) {
                case 'read':
                    return 'mdi mdi-48px  mdi-glasses ';
                case 'create':
                    return 'mdi mdi-48px  mdi-plus';
                case 'edit':
                    return 'mdi mdi-48px  mdi-pencil';
                case 'administrator':
                    return 'mdi mdi-48px  mdi-cog';
            }
        },
        setAllowAnonymous(e) {
            this.project.allowAnonymous = e.target.checked;
        },
    },
};
</script>

<style scoped>
.lb-project-privacy-option {
    height: 5.5rem;
    width: 6.5rem;
    border: none;
}
</style>
